export enum LifecycleStageId {
    Opportunity = 1,
    Design = 2,
    Staging = 3,
    Installation = 4,
    Validation = 5,
    Baseline = 6,
    ControlPrep = 7,
    Subscription = 8,
    Deprecated = 9,
    New = 10,
    OrderPlacement = 11,
    SubscriptionNoControl = 12,
}

export const stageNames: { [key in LifecycleStageId]: string } = {
    [LifecycleStageId.Opportunity]: 'Opportunity',
    [LifecycleStageId.Design]: 'Design',
    [LifecycleStageId.Staging]: 'Staging',
    [LifecycleStageId.Installation]: 'Installation',
    [LifecycleStageId.Validation]: 'Validation',
    [LifecycleStageId.Baseline]: 'Baseline',
    [LifecycleStageId.ControlPrep]: 'Control prep',
    [LifecycleStageId.Subscription]: 'Subscription',
    [LifecycleStageId.Deprecated]: 'Deprecated',
    [LifecycleStageId.New]: 'New',
    [LifecycleStageId.OrderPlacement]: 'Order Placement',
    [LifecycleStageId.SubscriptionNoControl]: 'Subscription No Control',
};

export enum BooleanTask {
    APPROVE_PID = 'approve-pid',
    STAGING_READY = 'staging-ready',
    AIR_EXPERT_APPROVAL = 'air-expert-approval',
    KPI_RANGES_VALIDATION = 'kpi-ranges-validation',
    INSTALLATION_IMAGES_TAKEN = 'installation-images-taken'
}

export enum DateRangeTask {
    BASELINE_PERIOD = 'baseline-period',
    INSTALLATION_DATES = 'installation-dates',
}

export enum DateTask {
    KICKOFF_MEETING_DATE = 'kickoff-meeting-date',
    PARTS_ARRIVED_DATE = 'parts-arrived-date',
    PLANNED_INSTALLATION_DATE = 'planned-installation-date',
    INSTALLATION_VALIDATION_DATE = 'installation-validation-date',
    TRAINING_MEETING_DATE = 'training-meeting-date',
    ENGINE_ACTIVATION_DATE = 'engine-activation-date',
    PO_START_DATE = 'po-start-date',
    ENGINE_CREATION_DATE = 'engine-creation-date',
}

export enum EnumTask {
    OPTIMIZE_NOT_CONTROLLED_STATION = 'optimize-not-controlled-station',
}

export enum LinkTask {
    MEETING_PRESENTATION = 'meeting-presentation',
    STATION_AS_BUILT = 'station-as-built',
    LINK_BOM_DOCUMENT = 'link-bom-document',
    BASELINE_REPORT = 'baseline-report',
    TRAINING_SESSION_SUMMARY = 'training-session-summary',
    INSTALLATION_APPROVAL_REPORT = 'installation-approval-report',
    COMPRESSOR_CONTROL_TEST_EXECUTED = 'compressor-control-test-executed'
}

export enum TextTask {
    ORDER_PURCHASE_NUMBER = 'order-purchase-number',
    PARTS_TRACKING = 'parts-tracking',
    CONTRACT_NUMBER = 'contract-number',
    ENGINE_VERSION = 'engine-version',
    PARTS_ORDER_NUMBER = 'parts-order-number',
}

export enum UserIdTask {
    ASSIGN_CS_OWNER = 'assign-cs-owner',
    ASSIGN_ENGINE_OWNER = 'assign-engine-owner',
}

export enum UnitsTask {
    KW_COST = 'kw-cost'
}

export enum PercentageTask {
    SAVINGS_COMMITMENT = 'savings-commitment'
}

export enum MeasurementUnitTask {
    AVERAGE_SPECIFIC_POWER = 'average-specific-power'
}